import * as React from 'react'
import type { SizeType } from '../interface'

export const SizeContext = React.createContext<SizeType>(undefined)
